import formatFns from 'date-fns/format';
import parseFns from 'date-fns/parse'
import parseISO from 'date-fns/parseISO';
import toDateFns from 'date-fns/toDate';
import { format as formatujTz, utcToZonedTime } from "date-fns-tz";

const pad = (i: number): string => i < 10 ? `0${i}` : `${i}`;

export function parse(date: string, formatString?: string): Date {
  if (!date)
    return null;
  if (formatString) {
    return parseFns(date, formatString, new Date());
  }
  return parseISO(date);
}

export function format(date: Date | number, formatString: string = "yyyy-MM-dd'T'HH:mm:ss"): string {
  return formatFns(date, formatString);
}
// clone
export function toDate(date: Date | number): Date {
  return toDateFns(date);
}

export function parseAndFormat(date: string, formatString?: string): string {
  return format(parse(date), formatString);
}


export function toUTCString(date: Date): string {
  const fmt = "yyyy-MM-dd'T'HH:mm:ss'Z'";
  const tz = "UTC";
  return formatujTz(utcToZonedTime(date, tz), fmt, { timeZone: tz });
}

export function formatTime(hour, minute, second): string {
  return `${pad(hour)}:${pad(minute)}:${pad(second)}`;
}

/**
 * Tworzy obiekt @name Date na podstawie dwóch @name date i @name time.
 * @param date
 * @param time czas podany w formacie 'HH:mm:ss'
 * @returns
 */
export function createDate(date: string, time: string): Date {
  const d = parse(date);
  const t = parse(time, 'HH:mm:ss');
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), t.getHours(), t.getMinutes(), t.getSeconds());
}

